export enum AccountLedgerReportTabs {
    BalanceAmount = 1,
    BalanceMetal  =2,
    ViewAllLedgerAmt = 3
}